var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashTop5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 54,
    viewBox: "0 0 55 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.666626,
    width: 54,
    height: 54,
    rx: 8,
    fill: "#FFEDD5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.4344 25.0178C35.1666 24.2855 35.1666 23.107 35.1666 20.75C35.1666 18.393 35.1666 17.2145 34.4344 16.4822M34.4344 25.0178C33.7022 25.75 32.5236 25.75 30.1666 25.75H25.1666C22.8096 25.75 21.6311 25.75 20.8989 25.0178M34.4344 25.0178C34.4344 25.0178 34.4344 25.0178 34.4344 25.0178ZM34.4344 16.4822C33.7022 15.75 32.5236 15.75 30.1666 15.75L25.1666 15.75C22.8096 15.75 21.6311 15.75 20.8989 16.4822M34.4344 16.4822C34.4344 16.4822 34.4344 16.4822 34.4344 16.4822ZM20.8989 16.4822C20.1666 17.2145 20.1666 18.393 20.1666 20.75C20.1666 23.107 20.1666 24.2855 20.8989 25.0178M20.8989 16.4822C20.8989 16.4822 20.8989 16.4822 20.8989 16.4822ZM20.8989 25.0178C20.8989 25.0178 20.8989 25.0178 20.8989 25.0178Z",
    stroke: "#EA580C",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9166 20.75C28.9166 21.4404 28.357 22 27.6666 22C26.9763 22 26.4166 21.4404 26.4166 20.75C26.4166 20.0596 26.9763 19.5 27.6666 19.5C28.357 19.5 28.9166 20.0596 28.9166 20.75Z",
    stroke: "#EA580C",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1666 19.5C33.0956 19.5 31.4166 17.8211 31.4166 15.75",
    stroke: "#EA580C",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1666 22C33.0956 22 31.4166 23.6789 31.4166 25.75",
    stroke: "#EA580C",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1666 19.5C22.2377 19.5 23.9166 17.8211 23.9166 15.75",
    stroke: "#EA580C",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1666 22C22.2377 22 23.9166 23.6789 23.9166 25.75",
    stroke: "#EA580C",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9166 37.4855H21.7415C23.0051 37.4855 24.2823 37.6171 25.512 37.8705C27.6873 38.3186 29.9777 38.3729 32.1753 38.0172C33.2589 37.8418 34.3242 37.5736 35.2885 37.1082C36.159 36.688 37.2253 36.0958 37.9415 35.4324C38.6568 34.77 39.4016 33.6858 39.9303 32.8384C40.3836 32.1118 40.1644 31.2202 39.4473 30.6788C38.6508 30.0774 37.4688 30.0775 36.6724 30.6791L34.4134 32.3855C33.5379 33.0469 32.5816 33.6557 31.4423 33.8374C31.3054 33.8592 31.1618 33.8791 31.0121 33.8965M31.0121 33.8965C30.967 33.9017 30.9213 33.9067 30.8751 33.9115M31.0121 33.8965C31.1943 33.8574 31.3753 33.7451 31.5451 33.5969C32.3491 32.8951 32.3999 31.7125 31.7023 30.9289C31.5405 30.7471 31.3511 30.5955 31.1405 30.4699C27.6438 28.3843 22.2034 29.9728 18.9166 32.3036M31.0121 33.8965C30.9665 33.9063 30.9208 33.9115 30.8751 33.9115M30.8751 33.9115C30.2209 33.9786 29.4556 33.996 28.6063 33.9158",
    stroke: "#EA580C",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 15.1666,
    y: 29.5,
    width: 3.75,
    height: 10,
    rx: 1.5,
    stroke: "#EA580C",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashTop5);
export default __webpack_public_path__ + "static/media/dash-top-5.0ec5aa9f20759733853ec629c4ca251e.svg";
export { ForwardRef as ReactComponent };